import { disablePageScroll, enablePageScroll } from 'scroll-lock'

const WebHelpers = {
  methods: {
    $_WebHelpers_supportsVideo () {
      return !!document.createElement('video').canPlayType
    },

    $_WebHelpers_supportshH264BaselineVideo () {
      if (!this.$_WebHelpers_supportsVideo()) {
        return false
      }

      const video = document.createElement('video')

      return !!video.canPlayType('video/mp4; codecs="avc1.42E01E, mp4a.40.2"')
    },

    $_WebHelpers_generateRandomId () {
      return Math.random().toString(36).substr(2, 9)
    },

    $_WebHelpers_disablePageScroll () {
      disablePageScroll()
    },

    $_WebHelpers_enablePageScroll () {
      enablePageScroll()
    }
  }
}

export default WebHelpers
